import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'

import { Flex, P } from 'ui/bend'

import { useUserContext } from 'context'
import { MyPraticeCards } from './MyPraticeCards'

const SummarySection = styled(Flex)(() =>
  css({
    gap: '32px',
    alignItems: 'center',
    justifyContent: 'center',
    '@media all and (max-width: 640px)': {
      gap: '16px'
    }
  })
)

const Summary = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid #ccc',
    padding: '16px 10px',
    borderRadius: '8px',
    width: '161px',
    '@media all and (max-width: 640px)': {
      width: '80px'
    }
  })
)

const SnapshotText = styled(P)(() =>
  css({
    textAlign: 'center',
    fontSize: '12px',
    textTransform: 'uppercase',
    marginBottom: '8px'
  })
)

const LibraryText = styled(P)(() =>
  css({
    textAlign: 'center',
    fontSize: '12px',
    textTransform: 'uppercase',
    marginTop: '24px',
    fontWeight: 400,
    lineHeight: '130%',
    letterSpacing: '0.48px'
  })
)

const SummaryNumber = styled(P)(() =>
  css({
    fontSize: '32px',
    lineHeight: '130%'
  })
)

const SummaryText = styled(P)(() =>
  css({
    fontSize: '15px',
    lineHeight: '12px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    height: '15px',
    '@media all and (max-width: 640px)': {
      fontSize: '11px',
      whiteSpace: 'normal',
      overflowWrap: 'break-word'
    }
  })
)

export const MyPraticeSummary = () => {
  const { user } = useUserContext()

  return (
    <>
      <Flex style={{ flexDirection: 'column', gap: '18px' }}>
        <div style={{ padding: '8px 0 6px 0' }}>
          <SnapshotText>30-Day Snapshot</SnapshotText>
          <SummarySection id='30-day-snapshot'>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.completedClassesCount}
              </SummaryNumber>
              <SummaryText>Classes Completed</SummaryText>
            </Summary>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.completedProgramsCount ||
                  0}
              </SummaryNumber>
              <SummaryText>Programs Completed</SummaryText>
            </Summary>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.weekStreak}
              </SummaryNumber>
              <SummaryText>Week Streak</SummaryText>
            </Summary>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.activeDays}
              </SummaryNumber>
              <SummaryText>Active Days</SummaryText>
            </Summary>
          </SummarySection>
          <LibraryText>MY LIBRARY</LibraryText>
        </div>
        <MyPraticeCards />
      </Flex>
    </>
  )
}
